import { render, staticRenderFns } from "./epb-text.component.vue?vue&type=template&id=2bc1fbb0&scoped=true"
import script from "./epb-text.component.vue?vue&type=script&lang=ts"
export * from "./epb-text.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-text.component.vue?vue&type=style&index=0&id=2bc1fbb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc1fbb0",
  null
  
)

export default component.exports